/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = All
 *
 * 1 = CheckedIn
 *
 * 2 = CheckedOut
 */
export enum LoanCarFilterStatus {
  All = 0,
  CheckedIn = 1,
  CheckedOut = 2,
}
